// src/utils/loadConfig.js
export async function loadUrlList() {
    // 获取当前域名
    const hostname = window.location.hostname;

    // 可选：移除 www. 前缀，防止干扰
    const cleanHost = hostname.replace(/^www\./, '');

    // 拼接对应 JSON 文件路径
    const configPath = `/configs/${cleanHost}.json`;

    // 拼接对应 JSON 文件路径
    let resJson;

    try {
        const res = await fetch(configPath);
        if (!res.ok) throw new Error('配置文件不存在');
        resJson = await res.json();
    } catch (e) {
        console.warn(`未找到 ${configPath}，尝试加载默认配置`);

        // 回退到默认配置，如 localhost.json 或 default.json
        try {
            const fallbackRes = await fetch('/configs/localhost.json');
            if (!fallbackRes.ok) throw new Error('默认配置也加载失败');
            resJson = await fallbackRes.json();
        } catch (fallbackErr) {
            console.error('配置加载失败：', fallbackErr);
            throw fallbackErr; // 彻底失败时仍抛出
        }
    }

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (resJson.iosUrl !== undefined && isIOS){
        let iosUrl =   resJson.iosUrl.replace(/^www\./, '');
        if(iosUrl !== cleanHost){
            // 域名跳转
            window.location.assign(encodeURI(resJson.iosUrl));
        }
    }else if (resJson.androidUrl !== undefined){
        let androidUrl =   resJson.androidUrl.replace(/^www\./, '');
        if(androidUrl !== cleanHost){
            // 域名跳转
            window.location.assign(encodeURI(resJson.androidUrl));
        }
    }

    return resJson;
}
